/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I withdraw a fixed deposit before it matures?`)
};

const es_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo retirar un depósito fijo antes de que venza?`)
};

const de_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich ein Festgeld vor Fälligkeit abheben?`)
};

const nl_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik een vaste storting vóór afloop opwaarderen?`)
};

const fr_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je retirer un placement à terme fixe avant sa maturité ?`)
};

const it_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso ritirare un deposito fisso prima che scada?`)
};

const pt_br2_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso sacar um depósito fixo antes de vencer?`)
};

const pt_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso levantar um depósito fixo antes de ele atingir a maturidade?`)
};

const ja_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期預金は満期前に引き出すことができますか？`)
};

const zh_sip_fd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以在定期存款到期前提前支取吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_faq3_q", locale)
	if (locale === "en") return en_sip_fd_faq3_q(inputs)
	if (locale === "es") return es_sip_fd_faq3_q(inputs)
	if (locale === "de") return de_sip_fd_faq3_q(inputs)
	if (locale === "nl") return nl_sip_fd_faq3_q(inputs)
	if (locale === "fr") return fr_sip_fd_faq3_q(inputs)
	if (locale === "it") return it_sip_fd_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_faq3_q(inputs)
	if (locale === "pt") return pt_sip_fd_faq3_q(inputs)
	if (locale === "ja") return ja_sip_fd_faq3_q(inputs)
	return zh_sip_fd_faq3_q(inputs)
};